import { UserListDTO } from '../user/user-list.dto';

export class CalendarEventUserEventsDTO {

    type: number;
    
    start: string | Date;

    end: string | Date;

    allDay: boolean;

    recurrence: string;

    duration: number;

    user: UserListDTO;

}
